// CriteoSpotLightAdvert renders <img src={mobile_background_image}> as the
// mandatory <picture> child (the desktop background_image is only a <source>
// override). A creative without a mobile image therefore can't paint on mobile
// and would produce an undefined img src, so require mobile_background_image.
const hasRenderableCreative = (item) =>
  Boolean(
    item &&
    typeof item === "object" &&
    item.rendering &&
    item.rendering.mobile_background_image,
  );

// Criteo can return the on-site display (BDSS) banner under different
// placement keys/indices, and alongside other placements (e.g. sponsored
// products) when both are delivered in a single response. Scan every placement
// group rather than relying on a fixed key/index so the banner is still found.
const findSpotLightPlacement = (placements = []) => {
  for (const placementGroup of placements) {
    if (!placementGroup || typeof placementGroup !== "object") {
      continue;
    }

    for (const placementValue of Object.values(placementGroup)) {
      if (!Array.isArray(placementValue)) {
        continue;
      }

      const creative = placementValue.find(hasRenderableCreative);

      if (creative) {
        return creative;
      }
    }
  }

  return undefined;
};

export { hasRenderableCreative };
export default findSpotLightPlacement;
